import React from 'react'
import { useFieldArray as useHookFieldArray } from 'react-hook-form'
import PropTypes from 'prop-types'

/**
 * @author Miika Rantakaulio
 */
const HookFieldArray = ({ name, setMethods, control, children }) => {
  const arrayMethods = useHookFieldArray({ name, control })
  const { fields } = arrayMethods

  React.useEffect(() => {
    if (setMethods) {
      setMethods(arrayMethods)
    }
  }, [])

  return <>{children(fields)}</>
}

export const useFieldArray = ({ name, control }) => {
  const arrayMethods = useHookFieldArray({ name, control })
  return { ...arrayMethods }
}

HookFieldArray.propTypes = {
  /** Name of the fieldArray */
  name: PropTypes.string.isRequired
  // /**
  //  * Enables parent access to fieldArray methods e.g. append, remove.
  //  * See {@link https://react-hook-form.com/api/usefieldarray} for all
  //  * available methods.
  //  */
  // setMethods: PropTypes.func
}

export default HookFieldArray
